import {Checkbox} from "@material-ui/core";
import React, {useState} from "react";
import {addCheckboxTire, removeCheckboxTire} from "../../../core/redux/ActionCreator";
import {useDispatch, useSelector} from "react-redux";

const CheckBox=(props)=>{
    const dispatch = useDispatch();
    const tire = props.tireInfo;
    const selectedTires = useSelector(state => state.searchResultReducer.checkboxes);
    const [tireList, updateTireList] = useState(useSelector(state => state.searchResultReducer.filteredResults));
    const tireIndex = tireList.findIndex(t => t.gmPartNum === tire.gmPartNum);

    const handleChecked=(event)=>{
        event.preventDefault();
        const inArray = selectedTires.indexOf(tire.gmPartNum);
        if(tireList[tireIndex].selected){
            tireList[tireIndex] = {
                ...tireList[tireIndex],
                selected: false
            };
            updateTireList({tireList});

            dispatch(removeCheckboxTire(tire.gmPartNum));
        }else {
            if (inArray === -1) {
                dispatch(addCheckboxTire(tire.gmPartNum));
            }
            tireList[tireIndex] = {
                ...tireList[tireIndex],
                selected: true
            };
            updateTireList({tireList});
        }
    }

return(
    <div  className={"modecheckboxdeselectedm-xl"}>
        {tireIndex !== -1?
        <label><Checkbox checked={tireList[tireIndex].selected} className={'stat-checkbox'}
                         onClick={handleChecked}
                         name="compareCheck" data-dtm={'search results:'+tireList[tireIndex].brand +':' + tireList[tireIndex].name}/>
            <span>{tireList[tireIndex].selected?'Selected':'Compare'}</span>
        </label>:null}
    </div>
)
}

export default CheckBox;